module.exports = __webpack_public_path__ + "img/time.71c8df96.svg";